import React from "react";

export default function Header() {
  return (
    <div className="header">
      <img src="setos-cafe.png" alt="setos-cafe" />
    </div>
  );
}
